import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const DeleteRosterTemplate = async (id, token) => {
  const response = await axios.delete(
    `${baseUrl_SPB}/api/v1/rostertemplate/delete?id=${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response?.data;
};

export default DeleteRosterTemplate;